interface SwipeHandlers {
  onSwipeLeft?: (e: any, args: any) => void
  onSwipeRight?: (e: any, args: any) => void
  onSwipeUp?: (e: any, args: any) => void
  onSwipeDown?: (e: any, args: any) => void
  onTouchend?: (e: any, args: any, swp: any) => void
  onTouchstart?: (e: any, args: any) => void
  onTouchmove?: (e: any, args: any, swp: any) => void
}

export function getSwipeUtils(
  handlers: SwipeHandlers = {
    // onSwipeLeft
    // onSwipeRight
    // onSwipeUp
    // onSwipeDown
    // onTouchend
    // onTouchstart
    // onTouchmove
  },
) {
  let swp_xDown = 0
  let swp_yDown = 0
  let swp_xDiff = 0
  let swp_yDiff = 0
  let swp_timedown = 0

  const swpContentScrolled: boolean | any = (targetEl: Element, currentEl: Element) => {
    if (targetEl.scrollHeight > targetEl.clientHeight && targetEl.scrollTop > 0) {
      return false
    }
    const parentEl = targetEl.parentElement
    if (!parentEl || parentEl === currentEl) {
      return true
    }
    return swpContentScrolled(parentEl, currentEl)
  }

  const swpHandleTouchend = (e: any, args: any) => {
    // if (!swpContentScrolled(e.target, e.currentTarget)) {
    // return
    // }

    const swipeThreshold = args?.swp_treshold || 20
    const swipeTimeout = args?.swp_timeout || 500

    const timeDiff = Date.now() - swp_timedown
    let eventType = ''
    const changedTouches = e.changedTouches || e.touches || []
    if (Math.abs(swp_xDiff) > Math.abs(swp_yDiff)) {
      if (Math.abs(swp_xDiff) > swipeThreshold && timeDiff < swipeTimeout) {
        if (swp_xDiff > 0) {
          eventType = 'onSwipeLeft'
        } else {
          eventType = 'onSwipeRight'
        }
      }
    } else if (Math.abs(swp_yDiff) > swipeThreshold && timeDiff < swipeTimeout) {
      if (swp_yDiff > 0) {
        eventType = 'onSwipeUp'
      } else {
        eventType = 'onSwipeDown'
      }
    }
    if (eventType !== '') {
      const eventData = {
        e,
        dir: eventType.replace(/swiped-/, ''),
        touchType: (changedTouches[0] || {}).touchType || 'direct',
        xStart: parseInt(String(swp_xDown), 10),
        xEnd: e.clientX ?? parseInt((changedTouches[0] || {}).clientX || -1, 10),
        yStart: parseInt(String(swp_yDown), 10),
        yEnd: e.clientY ?? parseInt((changedTouches[0] || {}).clientY || -1, 10),
      }

      if (handlers[eventType]) {
        handlers[eventType](eventData, args)
      }
    }
    if (handlers.onTouchend) {
      handlers.onTouchend(e, args, {
        swp_xDown,
        swp_yDown,
        swp_timedown,
        swp_xDiff,
        swp_yDiff,
      })
    }

    swp_xDown = 0
    swp_yDown = 0
    swp_timedown = 0
    swp_xDiff = 0
    swp_yDiff = 0
  }

  const swpHandleTouchstart = (e: any, args: any) => {
    swp_timedown = Date.now()
    swp_xDown = e.clientX ?? e.touches[0].clientX
    swp_yDown = e.clientY ?? e.touches[0].clientY
    swp_xDiff = 0
    swp_yDiff = 0

    if (handlers.onTouchstart) {
      handlers.onTouchstart(e, args)
    }
  }
  const swpHandleTouchmove = (e: any, args: any) => {
    if (!swpContentScrolled(e.target, e.currentTarget)) {
      swp_xDown = e.clientX ?? e.touches[0].clientX
      swp_yDown = e.clientY ?? e.touches[0].clientY
      return
    }
    if (!swp_xDown || !swp_yDown) return

    const xUp = e.clientX ?? e.touches[0].clientX
    const yUp = e.clientY ?? e.touches[0].clientY
    swp_xDiff = swp_xDown - xUp
    swp_yDiff = swp_yDown - yUp

    if (handlers.onTouchmove) {
      handlers.onTouchmove(e, args, { swp_xDiff, swp_yDiff })
    }
  }

  return {
    touchstart: swpHandleTouchstart,
    touchmove: swpHandleTouchmove,
    touchend: swpHandleTouchend,
  }
}
